import { Injectable, inject } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { GroupByPayload, ProjectionOperation } from "../models/vcloud-api";
import { EventsService } from "./events.service";
import { VCloudSmartApiService } from "./v-cloud-smart-api.service";
import { PaginationState } from "../../shared/models/pagination";
import { TableRow } from "../models/common-table";
import { DEFAULT_PAGE_SIZE } from "../../shared/constant/tables";

@Injectable({
  providedIn: "root",
})
export class PaginationService {
  private eventsService = inject(EventsService);
  private vcloudApi = inject(VCloudSmartApiService);

  public defaultLimit: number = 4900;

  public getTableRows(request: any): Observable<{ Results: { Group: string[]; Value: any[] }[] }> {
    const requestBody: GroupByPayload = {
      ...request.RequestBody,
      GroupBy: undefined,
      GroupByV2: undefined,
      Projection: [
        {
          Attribute: request.Attribute,
          Operation: ProjectionOperation.count,
          Distinct: true,
        },
      ],
      Filters: request.Filters,
    };
    return this.vcloudApi.groupBy(requestBody).pipe(
      catchError((err) => {
        this.eventsService.displayErrorToUser(err, "Get Table Rows");
        return of({ Results: [] });
      }),
    );
  }

  public handleDynamicPagination(
    state: PaginationState<TableRow>,
    lastLoadedPage: number,
  ): { limit: number; pagesToLoad: number } | undefined {
    const { pageNumber, pageSize } = state;

    if (lastLoadedPage !== -1 && pageNumber < lastLoadedPage) {
      return undefined;
    }

    const currentPageSize: number = pageSize ?? DEFAULT_PAGE_SIZE;
    const pagesToLoad: number = pageNumber - lastLoadedPage + this.defaultLimit / currentPageSize;

    return {
      limit: currentPageSize * pagesToLoad,
      pagesToLoad,
    };
  }
}
